export default {
  primary: '#01a8bb',
  secondary: '#69737a',
  accent: '#b7d8ad',
  success: '#25a345',
  error: '#d20032'
}
